module.exports = __webpack_public_path__ + "img/Website-Showroom-kleiner.e3e92bc0.png";